import { LOCAL_STORAGE_FREQUENT_VALUES } from '../Data/constants.js'
import isInIframe from './is-in-iframe.js'

export let localStorage = {
  getItem,
  setItem,
  removeItem,
}

let _storageWhenInIframe = {}

function getItem(key) {
  if (isInIframe()) {
    return _storageWhenInIframe[key]
  } else {
    return window.localStorage.getItem(key)
  }
}

function setItem(key, value) {
  if (isInIframe()) {
    _storageWhenInIframe[key] = value
  } else {
    window.localStorage.setItem(key, value)
  }
}

function removeItem(key) {
  if (isInIframe()) {
    delete _storageWhenInIframe[key]
  } else {
    window.localStorage.removeItem(key)
  }
}

export function windowAddEventListenerStorage(listener) {
  if (isInIframe()) return

  window.addEventListener('storage', listener)
}

export function windowRemoveEventListenerStorage(listener) {
  if (isInIframe()) return

  window.removeEventListener('storage', listener)
}

export function setFrequentlyUsedSelectionValue({ key, value, xid }) {
  let frequently_used_by_xid = `${LOCAL_STORAGE_FREQUENT_VALUES}_${xid}`
  let frequently_used = JSON.parse(
    localStorage.getItem(frequently_used_by_xid) || '{}'
  )
  let update = frequently_used[key] || []

  // remove any existing match by id
  update = update.filter(item => item.id !== value.id)

  // add to start
  update.unshift(value)

  // keep max 5
  update = update.slice(0, 5)

  frequently_used[key] = update
  localStorage.setItem(frequently_used_by_xid, JSON.stringify(frequently_used))
}

export function getFrequentlyUsedSelectionValues({ key, xid }) {
  let frequently_used_by_xid = `${LOCAL_STORAGE_FREQUENT_VALUES}_${xid}`
  let frequently_used = JSON.parse(
    localStorage.getItem(frequently_used_by_xid) || '{}'
  )
  return frequently_used[key] || []
}

export function resetFrequentlyUsedSelectionValues({ key, xid }) {
  let frequently_used_by_xid = `${LOCAL_STORAGE_FREQUENT_VALUES}_${xid}`
  let frequently_used = JSON.parse(
    localStorage.getItem(frequently_used_by_xid) || '{}'
  )

  frequently_used[key] = []
  localStorage.setItem(frequently_used_by_xid, JSON.stringify(frequently_used))
}
